import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'
import { ChannelModel } from 'Pages/referenceBooks'
import { oldChannelApi, oldChannelSlice, OldChannelNS } from 'Pages/user'

export function* getAll(action: OldChannelNS.GetAll) {
	try {
		const { params } = action.payload
		const res = yield* call(oldChannelApi.getAll, params)
		const entries = res.entries.map((channel): ChannelModel => Deserialize(channel, ChannelModel))
		const channels = Deserialize(res, ResponseCatalog)
		channels.entries = entries
		yield* put(oldChannelSlice.actions.setAll(channels))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const oldChannelsSaga = function* saga() {
	yield* takeLatest(oldChannelSlice.actions.getAll.type, getAll)
}
